import { render, staticRenderFns } from "./glIcon.vue?vue&type=template&id=eb413042"
import script from "./glIcon.vue?vue&type=script&lang=js"
export * from "./glIcon.vue?vue&type=script&lang=js"
import style0 from "./glIcon.vue?vue&type=style&index=0&id=eb413042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports